import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { ButtonComponent } from "../../../shared/components/button/button.component";
import { AuthService } from "../../services/auth.service";
import { SnackBarService } from "../../services/snack-bar.service";

@Component({
    selector: "app-welcome-page",
    imports: [ButtonComponent],
    templateUrl: "./welcome-page.component.html",
    styleUrl: "./welcome-page.component.scss"
})
export class WelcomePageComponent implements OnInit {
  private resetPasswordToken!: string;

  constructor(
    private router: Router,
    private readonly route: ActivatedRoute,
    private readonly authService: AuthService,
    private readonly snackbarService: SnackBarService,
  ) {}

  ngOnInit() {
    this.route.queryParamMap.subscribe((params) => {
      const token = params.get("confirmation_token");
      if (token) {
        this.resetPasswordToken = token;
        this.confirmEmail();
      } else {
        this.snackbarService.openSnackBar(
          "Token de confirmação inválido ou ausente.",
          "Fechar",
          "error",
        );
      }
    });
  }

  private confirmEmail() {
    this.authService.accountConfirmation(this.resetPasswordToken).subscribe({
      next: () => {
        this.snackbarService.openSnackBar(
          "Confirmação de email feita com sucesso!",
          "Fechar",
          "success",
        );
      },
      error: (error: string) => {
        console.error("Erro ao confirmar email:", error);
      },
    });
  }
  goToHome() {
    this.router.navigate(["/"]);
  }
}
